import { useCallback, useEffect, useRef, useState } from 'react';
import { container } from 'tsyringe';
import { SertifikatTTEPresenter } from '../../../../../data/presenters/SertifikatTTEPresenter';
import { LogTTEPengetahuan } from '../../../../../entities/LogTTEPengetahuan';
import { hasRunningLog } from './logTteStatus';

/** Interval refresh otomatis selama ada proses TTE yang berjalan. */
export const POLLING_INTERVAL_MS = 5000;

/**
 * State + fetch + polling untuk tabel Log TTE Pengetahuan.
 * Polling berhenti saat tidak ada proses berjalan atau tab browser tersembunyi.
 */
export const useLogTtePengetahuan = () => {
  const [data, setData] = useState<LogTTEPengetahuan[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [activity, setActivity] = useState('');
  const [resetPagination, setResetPagination] = useState(false);
  const requestId = useRef(0);

  const fetchData = useCallback(
    async (silent = false) => {
      const currentRequest = ++requestId.current;
      if (!silent) setIsLoading(true);

      try {
        const presenter = container.resolve(SertifikatTTEPresenter);
        const result = await presenter.logTTESertifikatPengetahuan(
          page,
          perPage,
          activity
        );
        // Abaikan respons usang (mis. filter berganti saat request berjalan)
        if (currentRequest === requestId.current) setData(result);
      } catch (e) {
        if (!silent) setData([]);
      } finally {
        if (!silent && currentRequest === requestId.current) {
          setIsLoading(false);
        }
      }
    },
    [page, perPage, activity]
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const running = hasRunningLog(data);

  useEffect(() => {
    if (!running) return undefined;

    const timer = setInterval(() => {
      if (!document.hidden) fetchData(true);
    }, POLLING_INTERVAL_MS);

    return () => clearInterval(timer);
  }, [running, fetchData]);

  const changeActivity = (value: string) => {
    setPage(1);
    setActivity(value);
    setResetPagination((prev) => !prev);
  };

  return {
    data,
    isLoading,
    page,
    perPage,
    activity,
    setPage,
    setPerPage,
    changeActivity,
    resetPagination,
    totalRows: data.length > 0 ? data[0].jumlah_data : 0,
  };
};
